import React from 'react';
import { RelatedBlock } from './RelatedBlock';
import { MAX_ITEMS_WITH_TWO_BLOCKS } from '.';

interface IRelatedPostsProps {
  relatedPosts: {
    seeMoreUrl?: string;
    title?: string;
    urls?: {
      url?: string;
      description?: string;
      thumbnailUrl?: string;
    }[];
  };
}

export const RelatedPosts = ({
  relatedPosts = { urls: [], seeMoreUrl: '' },
}: IRelatedPostsProps) => {
  return (
    <>
      <RelatedBlock
        type="post"
        seeMoreUrl={relatedPosts.seeMoreUrl}
        items={
          relatedPosts?.urls
            ?.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS)
            .map(({ url, thumbnailUrl, description }) => {
              return {
                url: url || '',
                thumbnailUrl: thumbnailUrl || '',
                description: description || '',
              };
            }) || []
        }
      />
    </>
  );
};
